import { Container } from "./StyledComponents";
import Counter from "./Counter";

export interface CounterContainerProps {
    startTime?: number;
    counterTextWhenEnds?: string;
}

const CounterContainer = (props: CounterContainerProps) => {
    const { startTime = 0, counterTextWhenEnds } = props;

    return (
        <Container className={"chromatic-ignore"}>
            <Counter
                className={"kms-ds-media-page-lobby-title-counter"}
                timestamp={startTime}
                textWhenEnds={counterTextWhenEnds}
            />
        </Container>
    );
};

export default CounterContainer;
